<script lang="ts">
	import { PUBLIC_ENVIRONMENT } from '$env/static/public';

	export let email: string;
	export let showCallToAction: boolean;
	export let signUpOnBuy: boolean = false;
	export let isCalloutStylingActive: boolean = false;
	export let isUsersPlan: boolean = false;

	const calloutStyling: string =
		'border-cyan-300 bg-cyan-100 bg-opacity-50 dark:border-cyan-300 dark:border-opacity-25 dark:bg-cyan-900 dark:bg-opacity-25 shadow-lg';

	// Stripe payment links
	const stripePaymentLink =
		PUBLIC_ENVIRONMENT === 'prod'
			? 'https://buy.stripe.com/4gM6oHftT5fc6ly3vQ0Fi0i'
			: 'https://buy.stripe.com/test_9B6eVd81rgXUeS41nI0Fi0a';
</script>

<div class="flex flex-col justify-center items-center">
	<div
		class={`w-[22rem] h-[36rem] p-8 flex flex-col justify-center items-center border rounded
			${isCalloutStylingActive ? calloutStyling : 'border-primary-200 bg-primary-50 dark:border-zinc-800 dark:bg-zinc-900'}`}
	>
		<div class="w-full flex flex-row justify-between items-center">
			<div class="flex flex-row items-center gap-2">
				<div class="w-fit text-zinc-900 dark:text-zinc-200 text-xl font-semibold">Project</div>
				{#if isUsersPlan}
					<div class="text-[10px] text-zinc-500 dark:text-zinc-400">(your current plan)</div>
				{/if}
			</div>
		</div>
		<div class="h-6"></div>
		<div class="w-full flex flex-col justify-start items-start">
			<div class="text-[13px]">
				<div
					class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
				>
					<i
						class="fa-solid fa-circle-check text-sms text-cyan-600 dark:text-cyan-400 dark:opacity-80"
					></i>
					<div class="w-4"></div>
					<div class="w-fit text-left">100 texture generations that never expire.</div>
				</div>
				<div
					class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
				>
					<i
						class="fa-solid fa-circle-check text-sms text-cyan-600 dark:text-cyan-400 dark:opacity-80"
					></i>
					<div class="w-4"></div>
					<div class="w-fit">Creations are fully private.</div>
				</div>
				<div
					class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
				>
					<i
						class="fa-solid fa-circle-check text-sms text-cyan-600 dark:text-cyan-400 dark:opacity-80"
					></i>
					<div class="w-4"></div>
					<div class="w-fit text-left">Commercial use license.</div>
				</div>
				<div
					class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
				></div>
				<div
					class="w-full h-12 flex flex-row justify-left items-center text-zinc-900 dark:text-zinc-300 text-center"
				></div>
			</div>
		</div>
		<div class="h-6"></div>
		<div class="h-8"></div>
		<div class="h-6"></div>
		<div
			class="w-full h-12 flex flex-row justify-start items-center text-cyan-600 dark:text-cyan-300"
		>
			<div class="text-3.25xl font-semibold">$15</div>
			<div class="w-1"></div>
			<div class="w-10 text-xs text-zinc-600 dark:text-zinc-400">one-time</div>
		</div>
		<div class="h-6"></div>
		{#if showCallToAction}
			{#if signUpOnBuy}
				<a
					class="w-60 h-12 flex flex-row justify-center items-center text-md
					font-semibold rounded shadow-lg
					text-zinc-50 bg-cyan-700 hover:brightness-125
					dark:text-zinc-900 dark:bg-cyan-300 dark:hover:brightness-125"
					href="/sign-up"
				>
					Buy Project Pack
				</a>
			{:else}
				<a
					class="w-60 h-12 flex flex-row justify-center items-center text-md
					font-semibold rounded shadow-lg
					text-zinc-50 bg-cyan-700 hover:brightness-125
					dark:text-zinc-900 dark:bg-cyan-300 dark:hover:brightness-125"
					href="{stripePaymentLink}?prefilled_email={email}"
					target="_blank"
				>
					Buy Project Pack
				</a>
			{/if}
		{:else}
			<div
				class="w-60 h-12 flex flex-row justify-center items-center text-md rounded text-zinc-200"
			></div>
		{/if}
	</div>
</div>
